import InfiniteScrollTable from './InfiniteScrollTable';

export default InfiniteScrollTable;
